module.exports = __webpack_public_path__ + "static/banner_partnerships_544@2x-ed5b9b15cc8440b05ba4474d6f356025.png";